document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-testid="product-list"]');
  if (!section) return;

  const header = section.querySelector('.section-resource-list__header');
  const slideshow = section.querySelector('slideshow-component');

  if (!header || !slideshow) return;

  const caretSVG = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" style="width:28px;height:28px;display:block;">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" vector-effect="non-scaling-stroke" d="M8 4l6 6-6 6"/>
  </svg>`;


  const navWrapper = document.createElement('div');
  navWrapper.style.cssText = 'display:flex; gap:16px; align-items:center; align-self:center;';


  const prevBtn = document.createElement('button');
  prevBtn.innerHTML = `<span style="display:flex; transform:scaleX(-1);">${caretSVG}</span>`;
  prevBtn.style.cssText = 'background:none; border:none; cursor:pointer; padding:0; color:inherit; display:flex; align-items:center;';
  prevBtn.setAttribute('aria-label', 'Anterior');

  const nextBtn = document.createElement('button');
  nextBtn.innerHTML = `<span style="display:flex;">${caretSVG}</span>`;
  nextBtn.style.cssText = 'background:none; border:none; cursor:pointer; padding:0; color:inherit; display:flex; align-items:center;';
  nextBtn.setAttribute('aria-label', 'Siguiente');

  prevBtn.addEventListener('click', () => {
    const realPrev = slideshow.querySelector('[ref="previous"]');
    if (realPrev) realPrev.click();
  });

  nextBtn.addEventListener('click', () => {
    const realNext = slideshow.querySelector('[ref="next"]');
    if (realNext) realNext.click();
  });

  navWrapper.appendChild(prevBtn);
  navWrapper.appendChild(nextBtn);
  header.appendChild(navWrapper);


  // Efecto disabled: flecha más clara cuando no hay más slides
  function updateButtonStates() {
    const realPrev = slideshow.querySelector('[ref="previous"]');
    const realNext = slideshow.querySelector('[ref="next"]');

    if (realPrev) {
      prevBtn.style.opacity = realPrev.disabled ? '0.3' : '1';
      prevBtn.style.pointerEvents = realPrev.disabled ? 'none' : 'auto';
    }
    if (realNext) {
      nextBtn.style.opacity = realNext.disabled ? '0.3' : '1';
      nextBtn.style.pointerEvents = realNext.disabled ? 'none' : 'auto';
    }
  }

  const realPrevBtn = slideshow.querySelector('[ref="previous"]');
  const realNextBtn = slideshow.querySelector('[ref="next"]');
  const observer = new MutationObserver(updateButtonStates);
  if (realPrevBtn) observer.observe(realPrevBtn, { attributes: true });
  if (realNextBtn) observer.observe(realNextBtn, { attributes: true });

  updateButtonStates();


  


  
});
